'use client';

import React from 'react';
import styled from 'styled-components';

export interface KbdProps extends React.HTMLAttributes<HTMLElement> {
  children?: React.ReactNode;
}

const Key = styled.kbd`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 1px 5px;
  border-radius: ${(p) => p.theme.radius.sm};
  background: ${(p) => p.theme.colors.neutral.panel};
  border: 1px solid ${(p) => p.theme.colors.neutral.line};
  color: ${(p) => p.theme.colors.neutral.inkMute};
  font-family: ${(p) => p.theme.fontFamily.mono};
  font-size: 10px;
  font-weight: ${(p) => p.theme.fontWeight.semibold};
  line-height: 1;
`;

/**
 * Inline keyboard-key chip for documenting shortcuts (`⌘K`, `Esc`,
 * `Shift+/`). Compose multiple `Kbd` elements in sequence for combinations.
 * The element is a real `<kbd>` so assistive tech announces the key.
 */
export function Kbd({ children, ...rest }: KbdProps) {
  return <Key {...rest}>{children}</Key>;
}
